(function () {
  'use strict';

  class MtFaq {
    constructor(root) {
      this.root = root;
      this.allowMultiple = root.dataset.allowMultiple === 'true';
      this.triggers = Array.from(root.querySelectorAll('.mt-faq__trigger'));
      this.destroyed = false;

      if (!this.triggers.length) {
        this.destroyed = true;
        return;
      }

      this.onClick = this.onClick.bind(this);
      this.init();
    }

    init() {
      this.root.querySelectorAll('.mt-faq__answer').forEach((answer) => {
        this.setupAnswer(answer);

        answer.addEventListener('transitionend', (e) => {
          if (e.propertyName !== 'height') return;
          if (answer.classList.contains('is-open')) {
            answer.style.height = 'auto';
          } else {
            answer.hidden = true;
          }
        });
      });

      this.root.addEventListener('click', this.onClick);
    }

    setupAnswer(answer) {
      const trigger = this.root.querySelector(
        '[aria-controls="' + CSS.escape(answer.id) + '"]'
      );
      const isOpen = trigger && trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        answer.hidden = false;
        answer.classList.add('is-open');
        answer.style.height = 'auto';
      } else {
        answer.hidden = true;
        answer.style.height = '0px';
      }
    }

    onClick(event) {
      const trigger = event.target.closest('.mt-faq__trigger');
      if (!trigger || !this.root.contains(trigger)) return;

      const answerId = trigger.getAttribute('aria-controls');
      if (!answerId) return;

      const answer = this.root.querySelector('#' + CSS.escape(answerId));
      if (!answer) return;

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.collapse(trigger, answer);
        return;
      }

      if (!this.allowMultiple) {
        this.triggers.forEach((other) => {
          if (other === trigger) return;
          const otherId = other.getAttribute('aria-controls');
          if (!otherId) return;
          const otherAnswer = this.root.querySelector('#' + CSS.escape(otherId));
          if (otherAnswer && other.getAttribute('aria-expanded') === 'true') {
            this.collapse(other, otherAnswer);
          }
        });
      }

      this.expand(trigger, answer);
    }

    expand(trigger, answer) {
      trigger.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      answer.classList.add('is-open');
      answer.style.height = '0px';
      const targetHeight = answer.scrollHeight;
      requestAnimationFrame(() => {
        answer.style.height = targetHeight + 'px';
      });
    }

    collapse(trigger, answer) {
      trigger.setAttribute('aria-expanded', 'false');
      const currentHeight = answer.scrollHeight;
      answer.style.height = currentHeight + 'px';
      answer.offsetHeight;
      answer.classList.remove('is-open');
      requestAnimationFrame(() => {
        answer.style.height = '0px';
      });
    }

    destroy() {
      this.root.removeEventListener('click', this.onClick);
      this.destroyed = true;
    }
  }

  const instances = new Map();

  function initFaq(scope) {
    if (!scope) scope = document;
    scope.querySelectorAll('[data-mt-faq]').forEach((root) => {
      if (instances.has(root)) return;
      const instance = new MtFaq(root);
      if (!instance.destroyed) {
        instances.set(root, instance);
      }
    });
  }

  function destroyFaq(scope) {
    if (!scope) scope = document;
    scope.querySelectorAll('[data-mt-faq]').forEach((root) => {
      const instance = instances.get(root);
      if (instance) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaq());
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaq(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyFaq(event.target);
  });
})();
